"use strict";
/**
 *
 * useDeepMemoOnValue
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const fast_equals_1 = require("fast-equals");
// Memoizes the passed value by performing the compairson defined in `valueIsEqual`;
function useValueIsEqual(value, valueIsEqual) {
    const ref = react_1.useRef(value);
    if (!valueIsEqual(ref.current, value)) {
        ref.current = value;
    }
    return ref.current;
}
exports.useValueIsEqual = useValueIsEqual;
// Memoizes the passed value by performing a deep compare.
function useDeepMemoOnValue(value) {
    return useValueIsEqual(value, fast_equals_1.deepEqual);
}
exports.useDeepMemoOnValue = useDeepMemoOnValue;
// Memoizes the passed value by performing a shallow compare.
function useShallowMemoOnValue(value) {
    return useValueIsEqual(value, fast_equals_1.shallowEqual);
}
exports.useShallowMemoOnValue = useShallowMemoOnValue;
